import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import './styles.scss';

const NewFlightSubtotal = ({ priceDetails }) => {
  const { currency, amount } = priceDetails;

  return (
    <div className="new-flight-subtotal d-flex align-center justify-between">
      <div>{I18n.t('components.ibe.exchange.cart.subtotal')}</div>
      <Amount className="exchange-cart-summary__amount" currency={currency} value={amount} />
    </div>
  );
};

NewFlightSubtotal.propTypes = {
  priceDetails: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
  }).isRequired,
};

export default NewFlightSubtotal;
